import React, { useState } from "react";
import PhoneInput from "./PhoneInput";
import { useTranslation } from "next-i18next";
import { formatPhoneNumber, isValidPhoneNumber } from "@utils";
import { useMutation } from "@apollo/client";
import { SUBSCRIBE_CARE } from "@operations/leads/mutations";
import ConfirmationPopUp from "./ConfirmationPopup";
import PropTypes from "prop-types";
import * as ga from "@lib/ga";
import { Grid, Typography } from "@mui/material";
import Link from "next/link";

const PhoneInputContainer = (props) => {
  const { t } = useTranslation(["common"]);

  const [phone, setPhone] = useState("");
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [subscribeToCare] = useMutation(SUBSCRIBE_CARE, {
    onError: () => {},
    onCompleted: () => {
      setPhone("");
      setConfirmPopup(true);
    },
  });

  const handlePhoneValueChange = (value) => {
    setPhone(value);
  };

  const handlePhoneValueSubmit = () => {
    const formattedPhone = formatPhoneNumber(phone);
    ga.event({
      action: "conversion",
      params: { send_to: "AW-331300454/MVJcCP-in4sDEOb8_J0B" },
    });
    ga.event({
      action: "User registration",
    });
    return subscribeToCare({
      variables: {
        phone: formattedPhone,
      },
    });
  };

  return (
    <>
      <PhoneInput
        placeholder={t("enter_phone_no")}
        id="phone"
        onClick={handlePhoneValueSubmit}
        onChange={handlePhoneValueChange}
        value={phone}
        disabled={!isValidPhoneNumber(phone)}
        inputProps={props.inputProps || {}}
        color={props.color}
      />
      {props.showTerms && (
        <Grid>
          <Typography
            align="center"
            px={3}
            my={1}
            variant="text"
            color={props.color}
          >
            {t("accept_terms_statement1")}
            <Link href="/terms_of_use" passhref>
              <a target="_blank">{t("terms_of_use")}</a>
            </Link>
            {t("and")}
            <Link href="/privacy_policy" passhref>
              <a target="_blank">{t("privacy_policy")}</a>
            </Link>
          </Typography>
        </Grid>
      )}
      {confirmPopup && (
        <ConfirmationPopUp
          open={confirmPopup}
          handleClose={() => setConfirmPopup(false)}
        />
      )}
    </>
  );
};

PhoneInputContainer.defaultProps = {
  id: "",
  inputProps: {},
  color: "primary",
  showTerms: true,
};

PhoneInputContainer.propTypes = {
  id: PropTypes.string,
  inputProps: PropTypes.object,
  color: PropTypes.oneOf(["primary", "secondary"]),
  showTerms: PropTypes.bool,
};

export default PhoneInputContainer;
